import { IngredientType } from '@libs/trip-planner-interfaces';
import type {
  OwnStayIngredientAdapter,
  OwnStayIngredientResponse,
} from '@libs/trip-planner-interfaces';
import { assertValue } from '@libs/utils';

import { assertSmartSearchValue } from '../../utils';

import type { IngredientResponseQL } from './itineraryResponseQL';
import { toActivityIngredientResponse } from './activityIngredientResponseQL';

export type OwnStayIngredientResponseQL = Extract<
  IngredientResponseQL,
  { type: 'OwnStayResultQL' }
>;
export function toOwnStayIngredientResponse(
  result: OwnStayIngredientResponseQL,
  ingredient: OwnStayIngredientAdapter
): OwnStayIngredientResponse {
  assertSmartSearchValue(result.date);
  assertSmartSearchValue(result.numberOfNights);

  return {
    date: new Date(result.date),
    ingredientId: ingredient.ingredientId,
    ingredientType: IngredientType.OwnStay,
    isAvailable: true,
    numberOfNights: result.numberOfNights,
    isNumberOfNightsSuggested: !ingredient.numberOfNights,
    subIngredientResponse:
      result.subIngredientResults?.map((subResult, subIndex) => {
        assertSmartSearchValue(subResult);

        const subIngredient = ingredient.subIngredients[subIndex];

        assertValue(
          subIngredient,
          'search-service-smart-search > mappers.ts > toOwnStayIngredientResponse > subIngredient'
        );

        if (subResult.type === 'TicketIngredientResponseQL') {
          return toActivityIngredientResponse(subResult, subIngredient);
        } else {
          throw new Error('Unhandled subIngredient type');
        }
      }) ?? [],
  };
}
